import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../../../../components/common/Icon/Icon';
import { IconKeys } from '../../../../components/common/Icon/IconKeys';
import S from './TripErrorsWarningStyles';

type Props = {
  errors: string[];
};

function TripErrorsWarning({ errors }: Props): JSX.Element | null {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null);
  const iconRef = useRef<HTMLDivElement>(null);

  if (errors.length === 0) return null;

  const showPopup = (): void => {
    const rect = iconRef.current?.getBoundingClientRect();
    if (rect) {
      setPosition({ top: rect.bottom + 8, left: rect.left });
    }
    setVisible(true);
  };

  const hidePopup = (): void => setVisible(false);

  return (
    <S.IconWrapper
      ref={iconRef}
      onMouseEnter={showPopup}
      onMouseLeave={hidePopup}
      onClick={(e) => e.stopPropagation()}
    >
      <Icon iconKey={IconKeys.ALERT_CIRCLE} />
      {visible && position && createPortal(
        <S.Popup style={{ top: position.top, left: position.left }}>
          <S.PopupTitle>Trip data issues</S.PopupTitle>
          <S.PopupList>
            {errors.map((error) => (
              <S.PopupListItem key={error}>{error}</S.PopupListItem>
            ))}
          </S.PopupList>
        </S.Popup>,
        document.body,
      )}
    </S.IconWrapper>
  );
}

export default TripErrorsWarning;
